import React, { useState, useEffect, useContext } from "react"
import { NavLink } from 'react-router-dom';
import MonthPickerComponent from '../../Utils/MonthPickerComponent'
import { TableDownloadContext } from '../../Contexts/TableDownloadContext'
import moment from 'moment';
import line from "../../images/line.png"
import xls from "../../images/xls/png/Group 47.png"
import FileIcon from "../../images/file.png"
import FileIconBlur from "../../images/fileblur.png"
// import ExcelPopup from "../../Components/ExcelPopup";
import '../MainMenu.css'
import { routeNames } from "../../routeSegments";
import ExportPopup from "../ExportPopup";
import { vcInvestmentExportData, vcExitExportData, vcbackedIPOExportData, vcangelInvestmentExportData, vcincubationExportData } from "../ExportPopup/ExportData";

import SavedFilterContent from "../../Components/SavedFilter";
import SavedFilterICON from "../../Components/SavedFilter/SavedFilterICON";
import { exportPDF } from "../../Config/config";
import { TableDataContext } from "../../Contexts/TableDataContext";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import Constants from "../../Constants";
import { UserContext } from "../../Contexts/UserContext";
import { useLocation } from "react-router";
import ExcelDownloader from "../shared/ExcelDownloader";
import { FaFilter, FaChartBar } from "react-icons/fa";
import { IoClose  } from "react-icons/io5";
import { Tooltip } from "antd";
import { RiMailDownloadLine } from "react-icons/ri";
import DownloadTrigger from "../ExportPopup/DownloadTrigger";


function MainMenu(props) {
    console.log(props, "menuprops");
    // const [save, setSave] = useState(false);
    const {save, setSave,showMonthPicker ,refineSearchFilters,groupId, dealsView, isMobile,setOpen,open,setIsMobile} = useContext(PeFilterContext);
    const {globalSearchResult} = useContext(TableDataContext);
    const { pathname } = useLocation();
    const { handleDownloadExcel } = useContext(TableDownloadContext)
    const {setCurrentPage} =useContext(TableDataContext);

    const [openTab, setOpenTab] = React.useState(1);
    const [showPopup, setShowPopup] = useState(false);
    const [date, setDate] = useState([
        moment().startOf("month").subtract(12, "months").format("YYYY-MM-DD"),
        moment().endOf("month").format("YYYY-MM-DD"),
    ]);
    /**
     * The function `savedList` toggles the value of the `save` variable.
     */
    const savedList = () => {
        setSave(!save)
    }
    const { isStudent,isTrialExport} = useContext(UserContext);

    const category =
      props.menu == "vc"
        ? "pevc"
        : props.menu == "exit-vc"
        ? "exit"
        : props.menu == "backedIpos-pe-vc" || props.menu == "VC-IPOs"
        ? "ipo"
        : props.menu == "angel" || props.menu == "vc-angel"
        ? "angel"
        : props.menu == "incubation" || props.menu == "vc-incubation"
        ? "incubation"
        : "";

        const menuTitles = {
          "vc": "VC Companies VC Investment - Venture Intelligence",
          "exit-vc": "VC Companies VC Exits - Venture Intelligence",
          "exit-ma-vc": "VC Companies Exits Via M&A (VC) - Venture Intelligence",
          "exit-pm-vc": "VC Companies Exits Via Public Market (VC) - Venture Intelligence",
          "VC-IPOs": "VC Companies VC Backed IPOs - Venture Intelligence",
          "angel": "VC Companies Angel Investments - Venture Intelligence",
          "incubation": "VC Companies Incubation - Venture Intelligence"
        };
        
        document.title = menuTitles[props.menu] || "Venture Intelligence";
        

        // console.log(props.menu , "ccccc")


    /* The above code is a React useEffect hook that sets the value of the "openTab" state variable to
    the value of the "props.active" prop. It is triggered whenever the "openTab" state variable
    changes. */
    useEffect(() => {
        setOpenTab(props.active)
    }, [openTab])

    useEffect(()=>{
      if (window.innerWidth < 800) {
          // setOpen(true);
          setIsMobile(true);
      }    },[])


    // const download = () => {
    //     handleDownloadExcel()
    // }
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false

    return (
      <div className="pt-0 pl-3 pr-4">
        <div className="scrollbar  rounded">
          <div className="px-2  md:px-3 rounded-[6px] rounded-b-none bg-white block lg:flex flex-row justify-between shadow-[0_2px_6px_0_rgba(0,0,0,0.08)]">
            <div className="flex flex-row  space-x-5 overflow-x-auto scrollbar-remove">
              <div></div>
            </div>

            <div
                className={
                  "md:flex justify-between items-center px-3 lg:px-2 py-2 space-x-4 " +
                  (showMonthPicker != 0 ? "" : "flex")
                }
              >
                <div></div>
                <div
                  className={
                    showMonthPicker != 0
                      ? "hidden md:flex space-x-3"
                      : "flex space-x-3"
                  }
                >
                  {isMobile && (
                  <>
                    {/* <button
                      className="cursor-pointer lg:ml-7 ml-4 mt-2"
                      onClick={() => setOpen(!open)}
                    >
                      <FaFilter color="#bc8b20" size={21} />
                    </button> */}
                      {/* {!open && <IoClose color="#bc8b20" size={25} className="fixed z-50 top-16 right-[39vw] mb-2" />} */}
                    <a>
                      <img
                        className="h-[24px] max-w-[2px] mt-1 "
                        src={line}
                      />
                    </a>
                  </>
                )}
                  {isStudent == "true" ? (
                    <></>
                  ) : (
                    <>
                      {/* <button
                        onClick={props.handleChartIconClick}
                        disabled={props.isChartLoading}
                        className={`flex items-center justify-center w-8 h-8 rounded-md transition-colors duration-200 ${
                          props.isChartLoading 
                            ? 'bg-gray-100 cursor-not-allowed' 
                            : 'hover:bg-gray-100'
                        }`}
                        title={props.isChartLoading ? "Loading Chart..." : "View Analytics Chart"}
                      >
                        {props.isChartLoading ? (
                          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-[#bc8b20]"></div>
                        ) : (
                          <FaChartBar 
                            size={22} 
                            className="text-[#bc8b20] mt-2 hover:text-[#9a7419]" 
                          />
                        )}
                      </button>
                      <img
                        alt=""
                        className="h-[24px] w-[2px] mt-1 "
                        src={line}
                      /> */}
                      <button>
                        {isTrialExport == "false" &&
                        props.typeId == Constants.moduleIds.companiesId ? (
                          <ExcelDownloader
                            url={exportPDF}
                            fileName={props?.exportFileName}
                            data={{
                              type:
                                props.menu === "vc"
                                  ? "vc_investment"
                                  : props.menu === "VC-IPOs"
                                  ? "vcipo"
                                  : props.menu === "angel"
                                  ? "angel"
                                  : props.menu === "incubation"
                                  ? "incubation"
                                  : props.menu === "exit-ma-vc"
                                  ? "vc_ma_exit"
                                  : props.menu === "exit-vc"
                                  ? "vc_exit"
                                  : props.menu === "exit-pm-vc"
                                  ? "vc_pm_exit"
                                  : "pe_vc_exit",
                            }}
                            children={
                              <DownloadTrigger />
                            }
                          />
                        ) : isTrialExport == "true" ? (
                          <DownloadTrigger onClick={() => setShowPopup(!showPopup)} />
                        ) : (
                          <></>
                        )}
                        {showPopup && (
                          <ExportPopup
                            onClose={() => setShowPopup(false)}
                            modules="company"
                            url={exportPDF}
                            fileName={props.exportFileName}
                            module_type={
                              props.primaryTypeMasterId ===
                              Constants.primaryMasterIds.vcId
                                ? "vc"
                                : "pe"
                            }
                            exportOptions={
                              props.menu === "vc"
                                ? vcInvestmentExportData
                                : props.menu === "VC-IPOs"
                                ? vcbackedIPOExportData
                                : props.menu === "angel"
                                ? vcangelInvestmentExportData
                                : props.menu === "incubation"
                                ? vcincubationExportData
                                : vcExitExportData
                            }
                            type={
                              props.menu === "vc"
                                ? "vc_investment"
                                : props.menu === "VC-IPOs"
                                ? "vcipo"
                                : props.menu === "angel"
                                ? "angel"
                                : props.menu === "incubation"
                                ? "incubation"
                                : props.menu === "exit-ma-vc"
                                ? "vc_ma_exit"
                                : props.menu === "exit-vc"
                                ? "vc_exit"
                                : props.menu === "exit-pm-vc"
                                ? "vc_pm_exit"
                                : "pe_vc_exit"
                            }
                          />
                        )}
                      </button>
                      
                    </>
                  )}
                  
                </div>
              </div>
          </div>
          
        </div>
      </div>
    );
}

export default MainMenu
